import React from 'react'
import Slider from '../inc/Slider'
import Navbar from '../inc/Navbar'
import ScrollToTop from "react-scroll-to-top";
import "./Home.css";
import LogoSlider from './LogoSlider';
import About from './About';
import Projectpage from './Projectpage';
import mitsubishiac from "../images/mitsubishi.jpg";
import carrier_ac from "../images/carrier.jpg";
import toshiba from "../images/toshiba.jpg";
import hitachi from "../images/Hitachi logo.jpg";
import daikin_ac from "../images/daikin_logo.jpg";

import SlideButton from './SlideButton';
import Toshiba from './Toshiba';
import coldroom from "../images/COLD ROOMS.jpg";
import coldroomac from "../images/CARRIER_COLD ROOMS.jpg";

import hitachi_worktime from "../images/work time.jpeg";
import hitachi_work from "../images/Hitachi Work.jpeg"
import ourwork from "../images/our work_saha Refrigeration.jpeg";
import ourwork_centralac from "../images/project (2).jpeg";
import centralizedac from "../images/work nadia ac.jpeg";
import centralizedacnadia from "../images/central ac.jpeg";
import centralizedac_saha from "../images/centralized ac.jpeg";
import centralizedac_install from "../images/Installed in the ceiling center.jpeg"


function Home() {
   const phoneNumber = "917407194440"; // Replace with your number (with country code, no +)
  const message = "Hello..";

  const encodedMessage = encodeURIComponent(message);
  const whatsappURL = `https://wa.me/${917407194440}?text=${encodedMessage}`;
  return (
    <div>
      <Navbar />
      <br />
      <br />
      <br />

      <br />
      <Slider />
      <ScrollToTop Smooth top="100" color="#48340A" />
      <div className='sahaRefrigeration'>
        <div className="album py-1">
          <div className="container mt-2">
            <div className="row">
              <marquee>
                <h5 style={{ color: "#F2192E" }} className=''>Welcome to Saha Refrigeration Air Conditions |  Best Centralized AC Sale & Services in Krishnanagar</h5>
              </marquee>
            </div>
          </div>
        </div>
      </div>
      <br />
      <div className="album py-1">
        <div className="container mt-2">
          <h1 className='mb-1' style={{ color: "#142C74" }}><b>SAHA REFIGERATION & AIR CONDITIONS</b></h1>

          <h1 className='mb-1' style={{ color: "#F2192E" }}><b>Authorized Dealer & Service </b></h1>
          <p><small>We are an officially authorized dealer offering genuine products and reliable after-sales service.</small></p>
        </div>
      </div>
      <LogoSlider />
      <br />

      <hr />
      <About />
      <SlideButton />

      <div style={{ color: "Green", display: 'flex', justifyContent: 'flex-start', margin: "5px" }} className="fixed-bottom  mb-1">
        <a href={whatsappURL} target="_blank" rel="noopener noreferrer">
          <button className='whatsAppicon highlight-btn'>
            <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="currentColor" class="bi bi-whatsapp" viewBox="0 0 16 16">
              <path d="M13.601 2.326A7.85 7.85 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.9 7.9 0 0 0 13.6 2.326zM7.994 14.521a6.6 6.6 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.56 6.56 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592m3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.73.73 0 0 0-.529.247c-.182.198-.691.677-.691 1.654s.71 1.916.81 2.049c.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232" />
            </svg>
          </button>
        </a>
      </div>
      <br />
      <hr />
      <div className="album py-0">
        <div className="container">
          <div className="row">
            <div className="col-md-4 mt-3">

              <div className="card" >
                <img src={mitsubishiac} className="card-img-top" alt="mitsubishiac" />
                <div className="card-body">
                  <h5 style={{ color: "#074198" }} className="card-title mb-1">MITSUBISHI ELECTRIC</h5>
                  <p className="card-text describe mb-2"><small>Split Air Conditioners, City Multi VRF System, Lossnay & Ventilation Products,
                    Air Curtain, Ceiling Cassette, Ceiling Concealed, High Static Ductable, Floor Standing, Window Air Conditioners</small></p>
                  <a href="tel: 7407194440" className="callbutton me-2"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-telephone-outbound-fill" viewBox="0 0 16 16">
                    <path fill-rule="evenodd" d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877zM11 .5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0V1.707l-4.146 4.147a.5.5 0 0 1-.708-.708L14.293 1H11.5a.5.5 0 0 1-.5-.5" />
                  </svg> Call Enquiry</a>
                  <a href="Mitsubishi" className="LearnMore">Learn More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-double-right" viewBox="0 0 16 16">
                    <path fill-rule="evenodd" d="M3.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L9.293 8 3.646 2.354a.5.5 0 0 1 0-.708" />
                    <path fill-rule="evenodd" d="M7.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L13.293 8 7.646 2.354a.5.5 0 0 1 0-.708" />
                  </svg></a>
                </div>
              </div>
            </div>
            <div className="col-md-4 mt-3">

              <div className="card" >
                <img src={carrier_ac} className="card-img-top" alt="carrier_ac" />
                <div className="card-body">
                  <h5 style={{ color: "#074198" }} className="card-title mb-1"> CARRIER</h5>
                  <p className="card-text mb-2"><small>Cassette R32, Ducted, Ducted Inverter</small></p>
                  <a href="tel: 7407194440" className="callbutton me-2"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-telephone-outbound-fill" viewBox="0 0 16 16">
                    <path fill-rule="evenodd" d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877zM11 .5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0V1.707l-4.146 4.147a.5.5 0 0 1-.708-.708L14.293 1H11.5a.5.5 0 0 1-.5-.5" />
                  </svg> Call Enquiry</a>
                  <a href="Carrier" className="LearnMore">Learn More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-double-right" viewBox="0 0 16 16">
                    <path fill-rule="evenodd" d="M3.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L9.293 8 3.646 2.354a.5.5 0 0 1 0-.708" />
                    <path fill-rule="evenodd" d="M7.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L13.293 8 7.646 2.354a.5.5 0 0 1 0-.708" />
                  </svg></a>
                </div>
              </div>
            </div>
            <div className="col-md-4 mt-3">

              <div className="card" >
                <img src={daikin_ac} className="card-img-top" alt="daikin_ac" />
                <div className="card-body">
                  <h5 style={{ color: "#074198" }} className="card-title mb-1"> DAIKIN</h5>
                  <p className="card-text mb-2"><small>Cassette all series, Ducted, Floor standing,  Ducted Inverter</small></p>
                  <a href="tel: 7407194440" className="callbutton me-2"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-telephone-outbound-fill" viewBox="0 0 16 16">
                    <path fill-rule="evenodd" d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877zM11 .5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0V1.707l-4.146 4.147a.5.5 0 0 1-.708-.708L14.293 1H11.5a.5.5 0 0 1-.5-.5" />
                  </svg> Call Enquiry</a>
                  <a href="daikin" className="LearnMore">Learn More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-double-right" viewBox="0 0 16 16">
                    <path fill-rule="evenodd" d="M3.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L9.293 8 3.646 2.354a.5.5 0 0 1 0-.708" />
                    <path fill-rule="evenodd" d="M7.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L13.293 8 7.646 2.354a.5.5 0 0 1 0-.708" />
                  </svg></a>
                </div>
              </div>
            </div>
            <div className="col-md-4 mt-3">

              <div className="card" >
                <img src={toshiba} className="card-img-top" alt="toshiba" />
                <div className="card-body">
                  <h5 style={{ color: "#074198" }} className="card-title mb-1"> TOSHIBA</h5>
                  <p className="card-text mb-2"><small>Cassette - SPI -premier | Cassette SPI-Classic</small></p>
                  <a href="tel: 7407194440" className="callbutton me-2"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-telephone-outbound-fill" viewBox="0 0 16 16">
                    <path fill-rule="evenodd" d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877zM11 .5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0V1.707l-4.146 4.147a.5.5 0 0 1-.708-.708L14.293 1H11.5a.5.5 0 0 1-.5-.5" />
                  </svg> Call Enquiry</a>
                  <a href="toshibaac" className="LearnMore">Learn More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-double-right" viewBox="0 0 16 16">
                    <path fill-rule="evenodd" d="M3.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L9.293 8 3.646 2.354a.5.5 0 0 1 0-.708" />
                    <path fill-rule="evenodd" d="M7.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L13.293 8 7.646 2.354a.5.5 0 0 1 0-.708" />
                  </svg></a>
                </div>
              </div>
            </div>


            <div className="col-md-4 mt-3">

              <div className="card" >
                <img src={hitachi} className="card-img-top" alt="hitachi" />
                <div className="card-body">
                  <h5 style={{ color: "#074198" }} className="card-title mb-1"> HITACHI</h5>
                  <p className="card-text mb-2"><small>Cassette - SPI -premier | Cassette SPI-Classic</small></p>
                  <a href="tel: 7407194440" className="callbutton me-2"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-telephone-outbound-fill" viewBox="0 0 16 16">
                    <path fill-rule="evenodd" d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877zM11 .5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-1 0V1.707l-4.146 4.147a.5.5 0 0 1-.708-.708L14.293 1H11.5a.5.5 0 0 1-.5-.5" />
                  </svg> Call Enquiry</a>
                  <a href="Hitachi" className="LearnMore">Learn More <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-double-right" viewBox="0 0 16 16">
                    <path fill-rule="evenodd" d="M3.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L9.293 8 3.646 2.354a.5.5 0 0 1 0-.708" />
                    <path fill-rule="evenodd" d="M7.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L13.293 8 7.646 2.354a.5.5 0 0 1 0-.708" />
                  </svg></a>
                </div>
              </div>
            </div>





          </div>
        </div>
      </div>
      <br />
      <div className="album py-2">
        <div className="container">
          <h3 style={{ color: "darkBlue" }}><b>COLD ROOM DETAILS :</b></h3>
        </div>
      </div>
      <div className="album py-1">
        <div className="container">

          <div className="accordion" id="accordionExample">
            <div className="accordion-item">
              <h2 className="accordion-header" id="headingOne">
                <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                  <b style={{ color: "darkBlue" }}>Cold Room </b>
                </button>
              </h2>
              <div id="collapseOne" className="accordion-collapse collapse show" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                <div className="accordion-body">

                  <div className="container">
                    <div className="row">
                      <div className="col-md-4 mt-3">
                        <img src={coldroom} className="card-img-top" alt="coldroom" />

                      </div>
                          <div className="col-md-4 mt-3">
                        <img src={coldroomac} className="card-img-top" alt="coldroomac_carrier" />

                      </div>
                    </div>

                  </div>


                </div>
              </div>
            </div>
            <div className="accordion-item">
              <h2 className="accordion-header" id="headingTwo">
                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                  <b style={{ color: "darkBlue" }}>Specification</b>
                </button>
              </h2>
              <div id="collapseTwo" className="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
                <div className="accordion-body">

                  <h6 className='mb-2'><b>WIDE RANGE OF SPECIFICATIONS</b></h6>
                  <p className='mb-1'>PANEL SPECIFICATIONS</p>
                  <p className='mb-1'>Panel Thickness: 60mm/80mm/100mm/120mm/150mm/200mm</p>
                  <p className='mb-1'>Panel Finish: PC/SS/GI/SLAB</p>
                  <p className='mb-1'>PUF Density: 40Kg/m³</p>
                  <p className='mb-1'>Thermal Conductivity: 0.019w/mk</p>
                  <p className='mb-1'>Closed Cells: 90-95%</p>
                  <p className='mb-1'>Operating Temperature: -60°C to +80°C</p>
                  <p className='mb-1'>Fire Resistance: Class B</p>
                  <p className='mb-1'>Skin Colour: RAL 9003"</p>

                </div>
              </div>
            </div>
            <div className="accordion-item">
              <h2 className="accordion-header" id="headingThree">
                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                  <b style={{ color: "darkBlue" }}>Description</b>
                </button>
              </h2>
              <div id="collapseThree" className="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#accordionExample">
                <div className="accordion-body">
                  <h6>Carrier-এর Cold Room প্রযুক্তি ১১০ বছরেরও বেশি কুলিং অভিজ্ঞতার ফল।
এই সিস্টেম বিশ্বব্যাপী প্রায় ১৭০টি দেশে ব্যবহৃত হয়।
Prefabricated panel ব্যবহার করে এগুলো তৈরি করা হয় এবং বিভিন্ন ব্যবসার প্রয়োজন অনুযায়ী custom design করা যায়। </h6>

                </div>
              </div>
            </div>


            {/* 
            <div className="accordion-item">
              <h2 className="accordion-header" id="headingSix">
                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseSix" aria-expanded="false" aria-controls="collapseSix">
                  <b>6.	KANYA SIDDHI : কন্যা সিদ্ধি </b>
                </button>
              </h2>
              <div id="collapseSix" className="accordion-collapse collapse" aria-labelledby="headingSix" data-bs-parent="#accordionExample">
                <div className="accordion-body">
                  <h6>1 মাস থেকে 10 বছর বয়স বাচ্চা মেয়ে   এর  জন্য
                    স্পেশাল স্কিমস. <br />
                    মেয়াদপূর্তিতে আকর্ষণীয় সুদের হার (সর্বোচ্চ মেয়াদপূর্তির সময়কাল 12 বছর
                  </h6>
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </div>
      <br />
      <Projectpage />
      <br />
      <Toshiba />
      <br />
      <div className='project'>
           <div className="album py-3">
        <div className="container">

       <h1 className="card-title"><b style={{color:"#ffffff"}}>Our Projects Central AC Installation </b></h1>
    <p style={{color:"#ffffff"}} className="card-text justify ">Central Cooling System Setup – Project Overview |  Saha Refrigeration & Air Conditions</p>
   
    </div>
    </div>
    </div>

         <div className="album py-0">
        <div className="container">
          <div className="row">
            <div className="col-md-3 mt-3">
             <img src={hitachi_worktime} className="card-img-top" alt="hitachi_worktime"/>

              </div>
               <div className="col-md-3 mt-3">
             <img src={hitachi_work} className="card-img-top" alt="hitachi_worktime"/>

              </div>
               <div className="col-md-3 mt-3">
             <img src={ourwork} className="card-img-top" alt="ourwork"/>
              </div>
               <div className="col-md-3 mt-3">
             <img src={ourwork_centralac} className="card-img-top" alt="ourwork"/>
              </div>
               <div className="col-md-3 mt-3">
             <img src={centralizedac} className="card-img-top" alt="ourwork centralizedac"/>
              </div>

              <div className="col-md-3 mt-3">
             <img src={centralizedacnadia} className="card-img-top" alt="ourwork centralizedac"/>
              </div>

              <div className="col-md-3 mt-3">
             <img src={centralizedac_saha} className="card-img-top" alt="ourwork centralizedac"/>
              </div>
              <div className="col-md-3 mt-3">
             <img src={centralizedac_install} className="card-img-top" alt="centralizedac_install"/>
              </div>
              </div>
              </div>
            </div>
<br/>

    </div>

  )
}

export default Home
